.bg{overflow:hidden;}